import { Button } from "@hoylu/client-common";
import React from "react";
import { useDispatch } from "react-redux";
import { loadWorkspaces } from "../state/workspaces/workspaces.actions";
import { useI18n } from "../utils/hooks/use.i18n";
import Styles from "./ErrorFetchingWorkspace.module.css";

export const ErrorFetchingWorkspace = () => {
  const dispatch = useDispatch();

  const t = useI18n("ERROR_FETCHING_WORKSPACE.");

  return (
    <div className={Styles.errorFetchingWorkspace}>
      <div className={Styles.errorMessage}>
        {t("ERROR_FETCHING_WORKSPACES")}
      </div>
      <Button
        onClick={() => {
          dispatch(loadWorkspaces.request({}));
        }}
        type="primary"
      >
        {t("TRY_AGAIN")}
      </Button>
    </div>
  );
};

export default ErrorFetchingWorkspace;
